import { OktaAuth } from "@okta/okta-auth-js";

export default (issuer: string, clientId: string): OktaAuth =>
  new OktaAuth({
    issuer,
    clientId,
    pkce: true,
    redirectUri: `${window.location.origin}/implicit/callback`,
  });
